import { useMemo } from 'react'
import { useCurrentChiNhanhId } from '@/hooks/useCurrentChiNhanhId'
import { useKhoVatLyOptions } from '@/hooks/useKhoVatLyOptions'

/** `khoVatLyId` của chi nhánh đang đứng (null nếu chưa map / đang tải). */
export function useCurrentKhoVatLyId(): number | null {
  const chiNhanhId = useCurrentChiNhanhId()
  const { chiNhanhRows, loading } = useKhoVatLyOptions()

  return useMemo(() => {
    if (loading || chiNhanhId == null) return null
    const row = chiNhanhRows.find((cn) => cn.id === chiNhanhId)
    const khoId = row?.khoVatLyId
    return khoId != null && khoId > 0 ? khoId : null
  }, [chiNhanhId, chiNhanhRows, loading])
}
